<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center mb-4">
                    <h5 class="card-title flex-grow-1 mb-0">Skills</h5>
                    <div class="flex-shrink-0">
                        <button @click="formContext.modal = true" class="btn btn-primary" type="button">
                            Add <span class="d-none d-sm-inline">Skill</span>
                        </button>
                    </div>
                </div>
                <CommonSpinner v-if="isLoading" />
                <div v-else class="row g-4">
                    <div v-for="(data, eduIndex) in pageData.data" :key="eduIndex" class="col-sm-6">
                        <div class="card border mb-0">
                            <div class="card-body p-3 d-flex justify-content-between">
                                <div class="me-3 text-start">
                                    <h6 class="text-primary">{{ data.skill_title }}</h6>
                                    <p class="text-muted mb-1">{{ data.skill_category_title }}</p>
                                    <span >{{ data.experience_level_title }} - {{ data.years_of_experience }} yrs</span>
                                </div>
                                <div>
                                    <div class="dropdown dropstart no-arrow">
                                        <button class="dropdown-toggle btn btn-sm rounded-circle btn-primary" type="button"
                                            role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="ri-more-2-fill align-bottom"></i>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <button @click.prevent="openEditView(data)" class="dropdown-item"
                                                    type="button"> Edit </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="!pageData.data.length">No skills added</p>
                </div>
            </div>
        </div>
        <b-modal size="lg" v-model="formContext.modal" hide-footer centered
            :title="formContext.editMode ? 'Update skill' : 'Add skill'" title-class="fs-6"
            @hide="closeEditView()">
            <skill-form v-if="formContext.modal" @closeMe="closeEditView()" :edit-mode="formContext.editMode"
                :edit-item="formContext.item" @addedItem="addItem($event)" @updatedItem="updateItem($event)" />
        </b-modal>
        
    </div>
</template>

<script>
import SkillForm from '@/components/forms/SkillForm.vue';
import { commonEditViewMixin } from '@/mixins/commonEditViewMixin';
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
    components: {
        SkillForm,
    },
    mixins: [
        commonEditViewMixin,
        commonPaginationMixin
    ],
    data() {
        return {
            isLoading: false
        }
    },
    methods: {
        addItem(item) {
            this.pageData.data.unshift(item);
        },
        updateItem(item) {
            const dataIndex = this.pageData.data.findIndex((i) => i.id == item.id)
            Object.assign(this.pageData.data[dataIndex], item)
        },
        fetchItems() {
            this.isLoading = true
            this.$http.get('/candidate-skills')
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.pageData = response.data.data
                        this.initializeAll();
                    }
                })
        },
        initializeAll() {
        },
    },
    created() {
        this.fetchItems()
    },
}
</script>

<style></style>